import { createReducer, on } from '@ngrx/store';
import { SettingsActions } from '@store/actions/settings.actions';
import { Settings, defaultSetting } from '@models/settings.model';

export interface SettingsState {
  settings: Settings,
  isLoading?: boolean,
  error?: any,
}
const initialState: SettingsState = {
    settings: defaultSetting,
    isLoading: false,
    error: null,
};

export const settingsReducer = createReducer(
    initialState,
    on(SettingsActions.loadSettingsSuccess, (state, { settings }) => ({
        ...state,
        settings: {
            ...state.settings,
            ...settings,
        },
        isLoading: false,
        error: null,
    })),
    on(SettingsActions.updateSettings, (state, { settings }) => ({
        ...state,
        settings: {
            ...state.settings,
            ...settings,
        },
        isLoading: false,
        error: null,
    })),
    on(SettingsActions.loadSettings, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),
    on(SettingsActions.loadSettingsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
